//InternshipItem.jsx

import React, { useContext, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Chip } from "@material-ui/core";
import { Stack } from "@mui/material";
import { Dropdown } from "react-bootstrap";
import { MoreVert } from "@material-ui/icons";
import { AuthContext } from "../../context/AuthContext";
import ENDPOINT from "../../context/EndPoint";
import axios from "axios";
import PublishIcon from "@mui/icons-material/Publish";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import NoAccountsIcon from "@mui/icons-material/NoAccounts";
import { useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";

const InternshipItem = ({ internship, userdata }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [showDelete, setShowDelete] = useState(false);
  const [showBenefits, setShowBenefits] = useState(false);

  const DeleteInternship = async () => {
    dispatch({ type: "LOADING" });
  
    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append("internship_id", internship.id);
    formData.append("action", "delete");
  
    try {
      const res = await axios.post(
        ENDPOINT + "admin-internship-actions.php",
        formData
      );
  
      if (res.data.status === "success") {
        dispatch({ type: "DONE_LOADING" });
        window.location.reload(); // simple refresh
      } else {
        dispatch({ type: "ERROR", payload: "Delete failed" });
      }
    } catch (err) {
      dispatch({ type: "ERROR", payload: err.message });
    }
  };
  const [submit, setsubmit] = useState(false);

  let benefitsList = [];

try {
  benefitsList = internship.perks ? JSON.parse(internship.perks) : [];
} catch (e) {
  benefitsList = [];
}
  
  return (
    <InternshipItemStyled>
      {/*INTERNSHIP ITEM START*/}
      <div className="internship-item bg-white col-lg-12 col-md-12 col-sm-12">
        <div className="d-flex justify-content-between w-100">
          <h1 className="internship-title  sm-16">{internship.title}</h1>

          <Dropdown className="options-dropdown">
            <Dropdown.Toggle className="bg-white text-dark options p-0 w-fit h-fit  border-0">
              <MoreVert className="text-dark" />
            </Dropdown.Toggle>
            <Dropdown.Menu>

            <Dropdown.Item
  onClick={() =>
    navigate("/add-internship", { state: { internship } })
  }
>
  <EditIcon fontSize="small" className="me-2" />
  Edit
</Dropdown.Item>

<Dropdown.Item onClick={() => setShowDelete(true)}>
  <DeleteForeverIcon className="me-2" />
  Delete
</Dropdown.Item>

            </Dropdown.Menu>
          </Dropdown>
        </div>
        <Stack direction="row" spacing={1}>
    
<div className="internship-info">
            <h6>Description</h6>
            <p>
              {internship.internship_description}
            </p>
          </div>

         






        </Stack>
        <div className="internship-info">
  <div className="d-flex justify-content-between align-items-center">
    <h6 className="m-0">Benefits</h6>

    {benefitsList.length > 0 && (
      <button
        className="btn btn-md btn-link"
        onClick={() => setShowBenefits(!showBenefits)}
      >
        {showBenefits ? "Hide" : "View"}
      </button>
    )}
  </div>

  {/* SHOW ONLY WHEN CLICKED */}
  {showBenefits && (
    <>
      {benefitsList.length > 0 ? (
        <ul className="mt-2 ps-3">
          {benefitsList.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      ) : (
        <p className="mt-2">No benefits mentioned</p>
      )}
    </>
  )}
</div>
        <div className="flex">
          {/* <div className="short-info col-6 col-lg-3 col-md-4 col-xl-4">
            {internship.status ? (
              <div className="flex">
                <h6 className="mr-2">Status : </h6>
                <p>{internship.status}</p>
              </div>
            ) : (
              ""
            )}
          </div> */}
        </div>
        <hr className="mt-0 mb-0" />
        <div className="short-info">
          <div className="internship-info sm-d-none">
            <h6>Mode</h6>
            <p>
              {internship.mode === "online" ? "online" : "In Office"}
            </p>
          </div>

          <div className="internship-info">
            <h6>Price</h6>
            <p>
              {" "}
              {internship.stipend === "0" ? (
                <p>Unpaid</p>
              ) : (
                "₹ " + internship.stipend
              )}
            </p>
          </div>

          <div className="internship-info">
            <h6>Duration</h6>
            <p>
              {internship.duration > 1
                ? internship.duration + " months"
                : internship.duration + " month"}
            </p>
          </div>

        
        </div>
        {/* <div className="bottom-flex">
         

          <Link className="sm-14"  to={"/internship/" + internship.id}>
            View Details
          </Link>

         


        </div> */}
      </div>
      {showDelete && (
  <div className="modal show d-block">
    <div className="modal-dialog">
      <div className="modal-content p-3">
        <h5>Are you sure?</h5>
        <div className="d-flex justify-content-end gap-2 mt-3">
          <button className="btn btn-secondary" onClick={()=>setShowDelete(false)}>Cancel</button>
          <button className="btn btn-danger" onClick={DeleteInternship}>Yes, Delete</button>
        </div>
      </div>
    </div>
  </div>
)}
      {/*INTERNSHIPS ITEM END*/}
    </InternshipItemStyled>
  );
};

export default InternshipItem;

export const InternshipItemStyled = styled.div`
  .internship-item {
    box-shadow: 0px 0px 2px #d2cbcb;
    padding: 15px;
    margin-bottom: 30px;
  }

  .short-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 10px 0px;
  }
  .internship-title {
    font-size: 20px;
  }
  .internship-tags {
    display: flex;
  }
  .bottom-flex {
    display: flex;
    justify-content: space-between;
    text-decoration: none;
  }
  a:hover {
    text-decoration: none;
  }
`;
